/**
 * Shared web map interaction. Tour route maps, Explore, and the hosting
 * picker must agree: wheel zooms toward the cursor, pinch still works on a
 * trackpad, the page does not scroll away while the pointer is over the map.
 *
 * `scrollZoom` is a Mapbox MapOptions flag (react-map-gl forwards it).
 * Do not revive `scrollZoom={Boolean(hideCountBadge)}` — that left Explore
 * and Tours disagreeing about what a mouse wheel means.
 */
export const WEB_MAP_SCROLL_ZOOM = true

export const WEB_MAP_CANVAS_STYLE = {
  width: '100%' as const,
  height: '100%' as const,
  touchAction: 'none' as const,
  overscrollBehavior: 'contain' as const,
}
